<template>
  <div style="background: #e5e5e5">
    <HeaderProduct
      title="Produtos | Configurações de produtos"
      text="Configure e edite categorias, os atributos e os grupos de atributos dos produtos IMPRIMAX."
      actionTitle="Novo Produto"
      @voltar="voltar('products')"
      :haveAction="false"
      :haveBack="true"
    />

    <v-container style="max-width: unset" class="pa-6 pt-2">
      <v-tabs class="px-0" background-color="#ECEEF1" grow height="55" hide-slider>
        <v-tab
          active-class="active-tab"
          class="tab"
          style="font-weight: bold !important"
          href="#mobile-tabs-5-0"
          @click="activeTab = 0"
        >
          <span>Subcategorias</span>
        </v-tab>

        <v-tab
          active-class="active-tab"
          class="tab"
          style="font-weight: bold !important"
          href="#mobile-tabs-5-1"
          @click="activeTab = 1"
        >
          <span>Categorias</span>
        </v-tab>

        <v-tab
          active-class="active-tab"
          class="tab"
          href="#mobile-tabs-5-2"
          @click="activeTab = 2"
        >
          <span>Atributos</span>
        </v-tab>

        <v-tab
          active-class="active-tab"
          class="tab"
          href="#mobile-tabs-5-3"
          @click="activeTab = 3"
        >
          <span>Grupos de Atributos</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item :value="0">
          <ProductsSubCategory :key="subcategoryKey" />
        </v-tab-item>

        <v-tab-item :value="1">
          <ProductsCategory :key="categoryKey" />
        </v-tab-item>

        <v-tab-item :value="2">
          <ProductsAtributes :key="attributeKey" />
        </v-tab-item>

        <v-tab-item :value="3">
          <ProductsAtributesGroup :key="attributeGroupKey" />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<style scoped>
.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}

.tab {
  font-weight: bold;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}

.back {
  background: #e9e9e9 !important;
  max-width: unset;
}

.filterAutocomplete {
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
}

.table-button {
  font-weight: bold;
  transition: 300ms;
}

.table-button:hover {
  background: #2d3038;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

.config {
  background-color: #ffffff !important;
  border: 1px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 10px;
  height: 50px;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import HeaderProduct from "../components/HeaderProduct/HeaderProduct.vue";
import ProductsCategory from "./components/ProductsCategory.vue";
import ProductsSubCategory from "./components/ProductsSubCategory.vue";
import ProductsAtributes from "./components/ProductsAtributes.vue";
import ProductsAtributesGroup from "./components/ProductsAtributesGroup.vue";

import Vue from "vue";

export default {
  data: () => ({
    subcategoryKey: 0,
    attributeGroupKey: 0,
    attributeKey: 0,
    categoryKey: 0,
    currentAttribute: {},
    currentCategory: {},
    currentAttributesGroups: {},
    categories: [],
    attributes: [],
    attributesGroup: [],
    closeNoLoading: false,
    editDialog: false,
    dialogKey: false,
    loading: false,
    isLoading: false,
    message: "",
    activeTab: 0,
    page: 1,
    totalPages: 1,
    pageSize: 15,
    sizes: [15, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 15,
    },
  }),

  async created() {},

  components: {
    HeaderProduct,
    ProductsCategory,
    ProductsAtributes,
    ProductsAtributesGroup,
    ProductsSubCategory,
  },

  methods: {
    filterTable() {
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;
    },

    voltar(rota) {
      this.$router.push("/products");
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize;
      this.updateTable();
    },

    page() {
      this.filter.page = this.page;
      this.updateTable();
    },
  },
};
</script>
